import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'
import { CollaborationDataType } from './types'

export const schema = z.object({
  questionId: z.string(),
  userId: z.string().optional(),
  sourceId: z.string().optional(),
  collaborationDataType: z.nativeEnum(CollaborationDataType),
  location: z
    .object({
      x: z.number(),
      y: z.number(),
      container: nullSafeOptionalString(),
      order: z.number().optional(),
    })
    .optional(),
  label: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    questionId: '',
    collaborationDataType: CollaborationDataType.figJam,
    location: { x: 0, y: 0 },
    label: '',
  })
)

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export type FirestoreRoomStateCollaborationData = z.infer<typeof schema>
